import { Component, Input, OnInit } from '@angular/core';
import { CaseStepInfo } from '../../../model/CaseStepInfo';
import { DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process } from '@progress/kendo-data-query';

@Component({
  selector: 'app-view-casestepinfo',
  templateUrl: './view-casestepinfo.component.html',
  styleUrls: ['./view-casestepinfo.component.scss']
})
export class ViewCasestepinfoComponent implements OnInit {
  public pageSize = 10;
  public skip = 0;
  public caseStepList: any;
  public gridViewData: any[];
  @Input() documentInfo: CaseStepInfo[] = [];
  @Input() packagesStatus: any;
  public gridState: DataStateChangeEvent = {

    skip: this.skip,
    take: this.pageSize
  };
  constructor() { }

  ngOnInit(): void {

  }
  ngOnChanges(): void {
    console.log(this.documentInfo);
    this.skip = 0;
    this.gridState.skip = this.skip;
    this.loadData();
  }

  pageChange(event: DataStateChangeEvent, gridId: string): void {

    this.gridState = event;
    this.caseStepList = process(this.documentInfo, this.gridState);
    this.gridViewData = this.documentInfo;
  }

  loadData(): void {
    if (Array.isArray(this.documentInfo)) {

      this.caseStepList = process(this.documentInfo, this.gridState);
      this.gridViewData = this.documentInfo;
    }
  }
}
